import { Link } from "react-router-dom";

const linkClass = "underline underline-offset-2 text-foreground/90 hover:text-foreground inline-flex min-h-11 items-center max-w-full break-words";

const Footer = () => (
  <footer className="mt-8 mb-20 px-4">
    <div className="mx-auto max-w-lg md:max-w-3xl lg:max-w-5xl">
      {/* Footer Links — high-contrast, wrap-safe for narrow viewports */}
      <nav aria-label="Footer navigation" className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-foreground mb-4">
        <Link to="/about" className={linkClass}>About Us</Link>
        <span aria-hidden="true" className="text-muted-foreground">·</span>
        <Link to="/articles" className={linkClass}>Browse All Guides</Link>
        <span aria-hidden="true" className="text-muted-foreground">·</span>
        <Link to="/privacy" className={linkClass}>Privacy Policy</Link>
        <span aria-hidden="true" className="text-muted-foreground">·</span>
        <Link to="/terms" className={linkClass}>Terms of Service</Link>
        <span aria-hidden="true" className="text-muted-foreground">·</span>
        <Link to="/contact" className={linkClass}>Contact</Link>
        <span aria-hidden="true" className="text-muted-foreground">·</span>
        <Link to="/accessibility" className={linkClass}>Accessibility Commitment</Link>
      </nav>

      {/* Accessibility Commitment */}
      <div className="mb-4 rounded-xl bg-card p-4 shadow-sm">
        <h2 className="text-sm font-bold text-foreground mb-2">♿ Accessibility Commitment</h2>
        <p className="text-xs leading-relaxed text-foreground/85">
          Sweet Baby Bloom is committed to ensuring digital accessibility for all users, including parents and caregivers with disabilities. We follow{" "}
          <abbr title="Web Content Accessibility Guidelines">WCAG</abbr> 2.1 Level AA standards and continuously improve the user experience for everyone. Our app uses semantic HTML, descriptive alt text, ARIA labels for interactive elements, keyboard-navigable interfaces, and sufficient color contrast ratios. If you encounter any accessibility barriers, please{" "}
          <Link to="/contact" className="font-semibold text-foreground underline underline-offset-2">Contact</Link> us so we can assist you.
        </p>
      </div>

      <p className="text-center text-[10px] text-muted-foreground">
        © {new Date().getFullYear()} Sweet Baby Bloom. All rights reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
